<template lang="pug">
aside-modal(id="categoryModal", width="w-xxxl", :loading="loading")
    span(slot="header-text") {{ categoryExists ? trans('category.update_category') : trans('category.create_category') }}
    div.p-a(slot="body")
        form(id="categoryForm")
            fieldset(:disabled="loading")
                div.md-form-group
                    input.md-input(
                        placeholder="e.g Food",
                        type="text",
                        v-model="category.name",
                        required
                    )
                    label Name

                div.md-form-group
                    input.md-input(
                        type="text"
                        v-model="category.code"
                    )
                    label Code

                div.md-form-group
                    input.md-input(
                        type="text"
                        v-model="category.external_code"
                    )
                    label External Code

                div.md-form-group
                    textarea(
                        rows="2",
                        class="md-input",
                        v-model="category.description"
                    )
                    label Description

                div.form-group
                    label.typo__label.multiselect-label Assign Products
                    multiselect(
                        v-model="category.products",
                        label="name",
                        track-by="id",
                        placeholder="Type to search",
                        :options="productList",
                        :multiple="true",
                        :close-on-select="false",
                        :hide-selected="false",
                        :max-height="400",
                        :limit="30",
                        :disabled="loading"
                        @search-change="refreshProductList"
                    )
                    small.block.m-t-sm {{ trans('category.assigned_product_category_will_be_overwritten_by_current_selected_category') }}

    button.btn.btn-fw.primary(
        slot="footer",
        @click="submit()",
        :disabled="onLoading('save-category') || !canManageItems"
    ) 
        v-loading(loader="save-category") Save
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Auth from '@js/plugins/auth';
import ProductMixin from '@js/mixins/products';

export default {
    mixins: [ProductMixin],

    data() {
        return {
            category: null,
        };
    },

    computed: {
        loading() {
            return (
                this.onLoading('fetch-category') ||
                this.onLoading('save-category')
            );
        },

        canManageItems() {
            return Auth.hasAnyPermission(
                'franchise_manage_items',
                'franchise_manage_categories',
            );
        },

        categoryExists() {
            return this.category.id !== null;
        },
    },

    created() {
        this.category = this.newCategory();
        this.getProductListIfNecessary();
    },

    mounted() {
        this.registerEvent();
    },

    methods: {
        ...mapActions('category', [
            'getCategory',
            'updateCategory',
            'createCategory',
        ]),

        newCategory() {
            return {
                id: null,
                name: null,
                code: null,
                external_code: null,
                description: null,
                products: [],
            };
        },

        toggleModal(action) {
            $('#categoryModal').modal(action);
        },

        registerEvent() {
            this.$on('show-category', id => {
                if (this.loading) return;

                if (id === null) {
                    this.category = this.newCategory();
                    this.toggleModal('show');
                } else {
                    this.getCategory(id)
                        .then(res => {
                            this.toggleModal('show');
                            this.category = _.pick(res.data, [
                                'id',
                                'name',
                                'code',
                                'external_code',
                                'description',
                                'products',
                            ]);
                        })
                        .catch(err => {
                            this.showApiError(err);
                        });
                }
            });
        },

        submit() {
            /** Promise */
            let save;

            if (!this.validateForm('categoryForm')) return;

            const products = this.category.products.map(p => p.id);

            const category = Object.assign(
                _.pick(this.category, [
                    'id',
                    'name',
                    'code',
                    'external_code',
                    'description',
                ]),
                { products },
            );

            if (!this.categoryExists) {
                save = this.createCategory(category);
            } else {
                save = this.updateCategory(category);
            }

            save.then(res => {
                this.showToastrSuccess();

                if (this.categoryExists) {
                    this.toggleModal('hide');
                } else {
                    this.category = this.newCategory();
                }

                this.$emit('category-saved');
            }).catch(err => {
                this.showApiError(err);
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/category/category-form.vue